import React from 'react';
import styled from 'styled-components';
import Head from 'next/head';
import {useCompany} from '../contexts/CompanyContext';
import {HeadingM, HeadingXS} from '../components/Typography';
import SimplePage from '../components/PageTemplates/SimplePage';
import useAxios from '../hook/useAxios';
import {fetchCompanyPrivacy} from '../utils/api';
import Loading from '../components/Loading';

export default function PrivacyPage() {
  const [company] = useCompany();

  const {result: privacyPolicy, loading} = useAxios(
    () => fetchCompanyPrivacy(company.id),
    []
  );

  const privacyTpl =
    privacyPolicy?.text && privacyPolicy?.text !== '<p></p>'
      ? privacyPolicy.text
      : `<p>Gentile Ospite, ai sensi del REGOLAMENTO (UE) 2016/679 per la protezione dei dati personali e del D.l.g.s.
n. 196/2003 , la informiamo che il trattamento dei suoi dati personali nell’ambito del servizio denominato
“Youmain” inclusi quelli relativi alla prenotazione dell’appuntamento per la videoconferenza e al suo
svolgimento (ad esempio i flussi audiovisivi e i documenti condivisi), saranno nella titolarità di <strong>${company?.name}</strong> e non della nostra società.</p>`;

  return (
    <>
      <Head>
        <title>Privacy Policy - {company?.name || 'Youmain'}</title>
        <meta
          property="og:title"
          content={`Privacy Policy - ${company?.name || 'Youmain'}`}
          key="title"
        />
      </Head>
      <Heading>
        <HeadingM>Privacy Policy</HeadingM>
        <HeadingXS>
          <em>
            Il seguente documento è stato revisionato e reso disponibile da{' '}
            {company?.name}, titolare del trattamento dei suoi dati personali.
          </em>
        </HeadingXS>
      </Heading>
      <Main>
        {loading && <Loading />}
        {!loading && <div dangerouslySetInnerHTML={{__html: privacyTpl}}></div>}
      </Main>
    </>
  );
}

PrivacyPage.layout = SimplePage;

const Main = styled.div`
  display: block;
  width: 70%;
  margin: 24px auto;

  @media ${(props) => props.theme.responsive.tablet} {
    width: 90%;
  }
`;

const Heading = styled.div`
  display: block;
  padding: 36px 15%;
  background-color: ${(props) => props.theme.colors.background};
  @media ${(props) => props.theme.responsive.tablet} {
    padding: 24px 5%;
  }

  h2 {
    margin-bottom: 0;
  }
`;
